/**
 * Service Worker Registration
 * Offline support ve caching için service worker'ı kaydeder
 */

export function initServiceWorker() {
    // Service Worker desteği var mı kontrol et
    if (!('serviceWorker' in navigator)) {
        console.log('[SW] Service Worker desteklenmiyor');
        return;
    }

    // Sayfa yüklendikten sonra kaydet
    window.addEventListener('load', () => {
        const rawAdminPath = document.body?.dataset?.adminBasePath || '/admin';
        const normalizedAdminPath = `/${String(rawAdminPath).replace(/^\/+|\/+$/g, '') || 'admin'}`;
        const serviceWorkerUrl = `/static/sw.js?admin=${encodeURIComponent(normalizedAdminPath)}`;
        navigator.serviceWorker
            .register(serviceWorkerUrl)
            .then((registration) => {
                console.log('[SW] Kayıt başarılı:', registration.scope);

                // Update kontrolü
                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing;

                    newWorker.addEventListener('statechange', () => {
                        if (
                            newWorker.state === 'installed' &&
                            navigator.serviceWorker.controller
                        ) {
                            // Yeni versiyon var!
                            console.log('[SW] Yeni versiyon mevcut');
                            showUpdateNotification();
                        }
                    });
                });

                // Periyodik update kontrolü (her 60 dakikada)
                setInterval(() => {
                    registration.update();
                }, 60 * 60 * 1000);
            })
            .catch((error) => {
                console.error('[SW] Kayıt başarısız:', error);
            });

        // Service Worker'dan mesaj dinle
        navigator.serviceWorker.addEventListener('message', (event) => {
            console.log('[SW] Mesaj alındı:', event.data);
        });
    });
}

/**
 * Kullanıcıya yeni versiyon bildirimi göster
 */
function showUpdateNotification() {
    // Basit banner ile bildirim
    const banner = document.createElement('div');
    banner.className = 'sw-update-banner';
    banner.innerHTML = `
    <div class="sw-update-banner__content">
      <p>🎉 Yeni bir versiyon mevcut!</p>
      <button class="sw-update-banner__btn" onclick="window.location.reload()">
        Yenile
      </button>
      <button class="sw-update-banner__close" onclick="this.parentElement.parentElement.remove()">
        ×
      </button>
    </div>
  `;

    // Stil ekle
    const style = document.createElement('style');
    style.textContent = `
    .sw-update-banner {
      position: fixed;
      bottom: 20px;
      right: 20px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      padding: 16px 20px;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.15);
      z-index: 10000;
      animation: slideIn 0.3s ease-out;
      max-width: 350px;
    }
    
    .sw-update-banner__content {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    
    .sw-update-banner__content p {
      margin: 0;
      flex: 1;
      font-size: 14px;
      font-weight: 500;
    }
    
    .sw-update-banner__btn {
      background: white;
      color: #667eea;
      border: none;
      padding: 8px 16px;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      font-size: 13px;
      transition: transform 0.2s;
    }
    
    .sw-update-banner__btn:hover {
      transform: scale(1.05);
    }
    
    .sw-update-banner__close {
      background: none;
      border: none;
      color: white;
      font-size: 24px;
      cursor: pointer;
      padding: 0;
      line-height: 1;
      opacity: 0.8;
      transition: opacity 0.2s;
    }
    
    .sw-update-banner__close:hover {
      opacity: 1;
    }
    
    @keyframes slideIn {
      from {
        transform: translateY(100px);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
    
    @media (max-width: 640px) {
      .sw-update-banner {
        left: 20px;
        right: 20px;
        max-width: none;
      }
    }
  `;

    document.head.appendChild(style);
    document.body.appendChild(banner);

    // 10 saniye sonra otomatik kapat
    setTimeout(() => {
        if (banner.parentElement) {
            banner.style.animation = 'slideIn 0.3s ease-out reverse';
            setTimeout(() => banner.remove(), 300);
        }
    }, 10000);
}

/**
 * Service Worker'ı kaldır (debug için)
 */
export function unregisterServiceWorker() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            registrations.forEach((registration) => {
                registration.unregister();
                console.log('[SW] Kaydı kaldırıldı');
            });
        });
    }
}
